<template>
  <div class="settings-container">
    <!-- 基本信息 -->
    <el-card class="settings-card">
      <div slot="header" class="card-header">
        <span>基本信息</span>
      </div>
      <el-form :model="branchInfo" label-width="120px" class="info-form">
        <el-form-item label="分身名称">
          <el-input v-model="branchInfo.shop_name" disabled />
        </el-form-item>
        <el-form-item label="负责人">
          <el-input v-model="branchInfo.contact_name" disabled />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="branchInfo.contact_phone" disabled />
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="branchInfo.username" disabled />
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 修改密码 -->
    <el-card class="settings-card">
      <div slot="header" class="card-header">
        <span>修改登录密码</span>
      </div>
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="120px" class="info-form">
        <el-form-item label="当前密码" prop="old_password">
          <el-input v-model="passwordForm.old_password" type="password" placeholder="请输入当前密码" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input v-model="passwordForm.new_password" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirm_password">
          <el-input v-model="passwordForm.confirm_password" type="password" placeholder="请再次输入新密码" show-password />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="passwordLoading" @click="handleChangePassword">修改密码</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 分红比例 -->
    <el-card class="settings-card">
      <div slot="header" class="card-header">
        <span>自定义分红比例</span>
        <el-tag size="small" type="info" style="margin-left: 8px;">当前比例：{{ branchInfo.dividend_ratio }}%</el-tag>
      </div>
      <el-form ref="ratioForm" :model="ratioForm" :rules="ratioRules" label-width="120px" class="info-form">
        <el-form-item label="分红比例" prop="dividend_ratio">
          <el-select v-model="ratioForm.dividend_ratio" placeholder="请选择分红比例" style="width: 200px;">
            <el-option label="50%" :value="50" />
            <el-option label="60%" :value="60" />
            <el-option label="70%" :value="70" />
            <el-option label="80%" :value="80" />
            <el-option label="90%" :value="90" />
            <el-option label="100%" :value="100" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="ratioLoading" @click="handleChangeRatio">保存分红比例</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 互动专区展示 -->
    <el-card class="settings-card">
      <div slot="header" class="card-header">
        <span>首页互动专区</span>
        <el-tag size="small" :type="interactForm.show_interact_section === 1 ? 'success' : 'info'"
          style="margin-left: 8px;">
          {{ interactForm.show_interact_section === 1 ? '展示中' : '已隐藏' }}
        </el-tag>
      </div>
      <el-form label-width="120px" class="info-form">
        <el-form-item label="展示互动专区">
          <el-switch v-model="interactForm.show_interact_section" :active-value="1" :inactive-value="0" active-text="展示"
            inactive-text="隐藏" />
          <div class="interact-tip">控制该分身 H5 首页是否展示"互动专区"（公益专区 / 乐枫达人 / 文化藏品）</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="interactLoading" @click="handleSaveInteractSection">保存互动专区设置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 分享设置 -->
    <el-card class="settings-card">
      <div slot="header" class="card-header">
        <span>分享设置</span>
        <el-tag size="small" type="info" style="margin-left: 8px;">微信"..."分享卡片</el-tag>
      </div>
      <el-form ref="shareForm" :model="shareForm" :rules="shareRules" label-width="120px" class="info-form">
        <el-form-item label="分享标题" prop="share_title">
          <el-input v-model="shareForm.share_title" placeholder="不填则使用默认标题" maxlength="100" show-word-limit />
          <div class="interact-tip">分享卡片标题，留空时使用默认标题"乐枫365 - 品质生活，从这里开始"</div>
        </el-form-item>
        <el-form-item label="分享描述" prop="share_desc">
          <el-input v-model="shareForm.share_desc" type="textarea" :rows="3" placeholder="不填则使用默认描述" maxlength="255"
            show-word-limit />
          <div class="interact-tip">分享卡片描述，留空时使用默认描述"好友通过你的分享进入，将自动形成合作关系"</div>
        </el-form-item>
        <el-form-item label="分享图片" prop="share_img">
          <el-upload class="share-upload" :action="uploadUrl" :headers="uploadHeaders" :show-file-list="false"
            :on-success="handleShareImgSuccess" :before-upload="beforeUpload" accept="image/*">
            <img v-if="shareForm.share_img" :src="shareForm.share_img" class="share-img-preview" />
            <i v-else class="el-icon-plus share-uploader-icon"></i>
          </el-upload>
          <div class="interact-tip">分享卡片图片，留空时自动使用首页第一张轮播图（无轮播图时用默认 Logo）。建议尺寸 500×400px，不超过5MB</div>
          <el-button v-if="shareForm.share_img" type="text" size="small" style="margin-top: 4px;"
            @click="shareForm.share_img = ''">清除图片</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="shareLoading" @click="handleSaveShareConfig">保存分享设置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 佣金费率设置 -->
    <el-card v-if="canManageCommissionConfig" class="settings-card">
      <div slot="header" class="card-header">
        <span>佣金费率设置</span>
        <el-tag size="small" :type="commission.enabled === 1 ? 'success' : 'info'" style="margin-left: 8px;">
          {{ commission.enabled === 1 ? '已开通自定义' : '未开通自定义' }}
        </el-tag>
      </div>
      <template v-if="commission.enabled === 1">
        <el-form :model="commission.items" label-width="150px" class="info-form">
          <el-form-item v-for="field in commissionFields" :key="field.key" :label="field.label">
            <el-input v-model="commission.items[field.key]"
              :placeholder="'留空表示使用总后台默认值 ' + defaultPercentText(field.key)" maxlength="20" clearable />
            <div class="interact-tip">小数比例（0~1，如 0.3 = 30%）。{{ field.tip }}</div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="commissionLoading"
              @click="handleSaveCommissionConfig">保存佣金费率</el-button>
            <el-button :loading="commissionLoading" @click="handleResetCommissionConfig">恢复默认（使用总后台）</el-button>
          </el-form-item>
        </el-form>
        <div class="interact-tip">说明：本分身商已配置的费率优先用于本域内新订单计算；未配置的项使用总后台"系统配置"中的默认值。</div>
      </template>
      <el-alert v-else title="总后台未开通本分身的自定义佣金费率权限，当前所有费率均按总后台系统配置执行" type="info" :closable="false" show-icon />
    </el-card>
  </div>
</template>

<script>
import { getUserInfo, changePassword, updateDividendRatio, updateInteractSection, getShareConfig, saveShareConfig, getCommissionConfig, saveCommissionConfig } from '@/api'

export default {
  name: 'Settings',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.new_password) {
        callback(new Error('两次输入的新密码不一致'))
      } else {
        callback()
      }
    }
    return {
      branchInfo: {
        shop_name: '',
        contact_name: '',
        contact_phone: '',
        username: '',
        dividend_ratio: 0
      },
      passwordForm: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      passwordRules: {
        old_password: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      ratioForm: {
        dividend_ratio: null
      },
      ratioRules: {
        dividend_ratio: [{ required: true, message: '请选择分红比例', trigger: 'change' }]
      },
      interactForm: {
        show_interact_section: 1
      },
      shareForm: {
        share_title: '',
        share_desc: '',
        share_img: ''
      },
      shareRules: {
        share_title: [{ max: 100, message: '分享标题不能超过100字', trigger: 'blur' }],
        share_desc: [{ max: 255, message: '分享描述不能超过255字', trigger: 'blur' }]
      },
      passwordLoading: false,
      ratioLoading: false,
      interactLoading: false,
      shareLoading: false,
      // 佣金费率配置
      commission: {
        enabled: 0,
        items: {
          commission_sales_rate: '',
          commission_platform_rate_first3: '',
          commission_platform_rate_after3: '',
          commission_platform_rate_cloud: ''
        },
        global_defaults: {
          commission_sales_rate: '0.3',
          commission_platform_rate_first3: '0.02',
          commission_platform_rate_after3: '0.08',
          commission_platform_rate_cloud: '0.08'
        }
      },
      commissionFields: [
        { key: 'commission_sales_rate', label: '销售奖励(佣金)比例', tip: '订单确认后给邀请人的销售奖励比例' },
        { key: 'commission_platform_rate_first3', label: '总台服务费(前三单)', tip: '推荐人前三单订单收取的总台服务费比例' },
        { key: 'commission_platform_rate_after3', label: '总台服务费(第四单起)', tip: '推荐人第四单及以上订单收取的总台服务费比例' },
        { key: 'commission_platform_rate_cloud', label: '总台服务费(云仓托管)', tip: '云仓托管商品订单收取的总台服务费比例' }
      ],
      commissionLoading: false
    }
  },
  computed: {
    uploadUrl() {
      return 'https://apighyx.zgyxszds.com/api/v1/supplier/upload'
    },
    uploadHeaders() {
      const token = localStorage.getItem('supplier_token')
      return token ? { Authorization: `Bearer ${token}` } : {}
    },
    canManageCommissionConfig() {
      return this.$store.getters.hasPermission('settings.commission')
    }
  },
  created() {
    this.fetchBranchInfo()
    this.fetchShareConfig()
    if (this.canManageCommissionConfig) {
      this.fetchCommissionConfig()
    }
  },
  methods: {
    fetchCommissionConfig() {
      getCommissionConfig().then(res => {
        this.commission.enabled = res.enabled ? 1 : 0
        const defaultItems = {
          commission_sales_rate: '',
          commission_platform_rate_first3: '',
          commission_platform_rate_after3: '',
          commission_platform_rate_cloud: ''
        }
        Object.keys(defaultItems).forEach(key => {
          const v = res.items ? res.items[key] : null
          defaultItems[key] = v !== null && v !== undefined && v !== '' ? String(v) : ''
        })
        this.commission.items = defaultItems
        if (res.global_defaults) {
          this.commission.global_defaults = res.global_defaults
        }
      }).catch(() => {
        // 错误已在拦截器提示
      })
    },
    defaultPercentText(key) {
      const raw = this.commission.global_defaults[key]
      const num = parseFloat(raw)
      if (isNaN(num)) {
        return raw || ''
      }
      return raw + '（' + num * 100 + '%）'
    },
    handleSaveCommissionConfig() {
      for (const field of this.commissionFields) {
        const val = String(this.commission.items[field.key] || '').trim()
        if (val !== '' && (isNaN(Number(val)) || Number(val) < 0 || Number(val) > 1)) {
          this.$message.error(`${field.label} 必须为 0~1 之间的小数（如 0.3 = 30%），留空表示使用总后台默认值`)
          return
        }
      }
      this.$confirm('确认保存佣金费率配置？本分身商域内的新订单将按新比例计算，历史订单不受影响。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.commissionLoading = true
        saveCommissionConfig({ ...this.commission.items }).then(() => {
          this.$message.success('佣金费率配置已保存')
          this.fetchCommissionConfig()
        }).catch(() => {
          // 错误已在拦截器提示
        }).finally(() => {
          this.commissionLoading = false
        })
      }).catch(() => { })
    },
    handleResetCommissionConfig() {
      this.$confirm('确认恢复为总后台默认费率？将清空本分身商全部自定义佣金费率。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.commissionLoading = true
        saveCommissionConfig({
          commission_sales_rate: '',
          commission_platform_rate_first3: '',
          commission_platform_rate_after3: '',
          commission_platform_rate_cloud: ''
        }).then(() => {
          this.$message.success('已恢复为总后台默认费率')
          this.fetchCommissionConfig()
        }).catch(() => {
          // 错误已在拦截器提示
        }).finally(() => {
          this.commissionLoading = false
        })
      }).catch(() => { })
    },
    fetchShareConfig() {
      getShareConfig().then(res => {
        this.shareForm = {
          share_title: res.share_title || '',
          share_desc: res.share_desc || '',
          share_img: res.share_img || ''
        }
      }).catch(() => {
        // 错误已在拦截器提示
      })
    },
    handleShareImgSuccess(response) {
      if (response.result === 'ok' && response.message) {
        this.shareForm.share_img = response.message
      }
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    handleSaveShareConfig() {
      this.$refs.shareForm.validate(valid => {
        if (!valid) return
        this.shareLoading = true
        saveShareConfig({
          share_title: this.shareForm.share_title,
          share_desc: this.shareForm.share_desc,
          share_img: this.shareForm.share_img
        }).then(() => {
          this.$message.success('分享设置已保存')
        }).catch(() => {
          // 错误已在拦截器提示
        }).finally(() => {
          this.shareLoading = false
        })
      })
    },
    fetchBranchInfo() {
      getUserInfo().then(res => {
        this.branchInfo = {
          shop_name: res.name || res.shop_name || '',
          contact_name: res.contact_name || '',
          contact_phone: res.phone || res.contact_phone || '',
          username: res.username || '',
          dividend_ratio: res.dividend_ratio || 0
        }
        this.ratioForm.dividend_ratio = this.branchInfo.dividend_ratio
        this.interactForm.show_interact_section = res.show_interact_section !== undefined ? res.show_interact_section : 1
      }).catch(() => {
        this.$message.error('获取分身商信息失败')
      })
    },
    handleSaveInteractSection() {
      this.interactLoading = true
      updateInteractSection({ show_interact_section: this.interactForm.show_interact_section }).then(() => {
        this.$message.success('互动专区展示设置已保存')
      }).catch(() => {
        // 错误已在拦截器提示
      }).finally(() => {
        this.interactLoading = false
      })
    },
    handleChangePassword() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return
        this.passwordLoading = true
        changePassword({
          old_password: this.passwordForm.old_password,
          new_password: this.passwordForm.new_password
        }).then(() => {
          this.$message.success('密码修改成功')
          this.$refs.passwordForm.resetFields()
        }).catch(() => {
          // 错误已在拦截器提示
        }).finally(() => {
          this.passwordLoading = false
        })
      })
    },
    handleChangeRatio() {
      this.$refs.ratioForm.validate(valid => {
        if (!valid) return
        this.$confirm(`确认将分红比例修改为 ${this.ratioForm.dividend_ratio}% ？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.ratioLoading = true
          updateDividendRatio({ dividend_ratio: this.ratioForm.dividend_ratio }).then(() => {
            this.$message.success('分红比例修改成功')
            this.branchInfo.dividend_ratio = this.ratioForm.dividend_ratio
          }).catch(() => {
            // 错误已在拦截器提示
          }).finally(() => {
            this.ratioLoading = false
          })
        }).catch(() => { })
      })
    }
  }
}
</script>

<style scoped>
.settings-container {
  max-width: 720px;
}

.settings-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  font-weight: bold;
}

.info-form {
  margin-top: 10px;
}

.interact-tip {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  margin-top: 6px;
}

.share-upload {
  display: inline-block;
}

.share-img-preview {
  width: 250px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}

.share-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 250px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

.share-uploader-icon:hover {
  border-color: #3a8ee6;
}
</style>
